import data from '../assets/translations/all.json';

export default (locale: string) => {
    const translations: Record<string, string> = {};

    for (const key in data) {
        const translation = data[key as keyof typeof data] as Record<string, string>;
        translations[key] = translation[locale];
    }

    return translations;
};
